module.exports = __webpack_public_path__ + "adf00f0d1e0a0aad2db9f9311a6536c7.png";